import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import DashboardBackdrop from 'components/DashboardBackdrop'
import DashboardResolvers from 'components/DashboardResolvers'
import DashboardCharts from 'components/DashboardCharts'
import DashboardInsights from 'components/DashboardInsights'
import TitledContent from 'components/TitledContent'
import CountUp from 'components/CountUp'
import Income from 'components/Income'
import NoData from 'components/NoData'
import {
  selectTotalBusinesses,
  selectTotals,
  selectEntities,
  selectResolvers,
  fetchData,
  resetTransmissions,
} from 'store/dashboard'
import { selectCurrentZone, setIsInitialized } from 'store/global'
import messages from './messages'
import styles from './Dashboard.scss'

function Dashboard({ intl }) {
  const dispatch = useDispatch()

  const totalBusinesses = useSelector(selectTotalBusinesses)
  const totals = useSelector(selectTotals)
  const entities = useSelector(selectEntities)
  const resolvers = useSelector(selectResolvers)
  const currentZone = useSelector(selectCurrentZone)

  const refetch = () => {
    dispatch(fetchData())
  }

  useEffect(() => {
    dispatch(setIsInitialized(true))

    return () => dispatch(resetTransmissions())
  }, [])

  useEffect(() => {
    refetch()
  }, [currentZone])

  return (
    <div className={styles.container}>
      <h1 className={styles.header}>
        <FormattedMessage {...messages.header} />
      </h1>
      <section className={styles.content}>
        <DashboardBackdrop className={styles.backdrop}>
          <main className={styles.overview}>
            <section className={styles.upper}>
              <div className={styles.totals}>
                <TitledContent
                  title={intl.formatMessage(messages.titles.totals.revenue)}
                  className={styles.total}
                  titleClassName={styles.totalTitle}
                  contentClassName={styles.totalContent}
                >
                  {totals.revenue ? <Income value={totals.revenue} /> : <NoData />}
                </TitledContent>
                <div className={styles.separator} />
                <TitledContent
                  title={intl.formatMessage(messages.titles.totals.cases)}
                  className={styles.total}
                  titleClassName={styles.totalTitle}
                  contentClassName={styles.totalContent}
                >
                  {totals.cases ? <CountUp to={totals.cases} /> : <NoData />}
                </TitledContent>
              </div>
              <div className={styles.entities}>
                <h3 className={styles.primaryTitle}>
                  <FormattedMessage {...messages.titles.entities} />
                  <span className={styles.totalEntities}>
                    <CountUp to={totalBusinesses} />
                  </span>
                </h3>
                <article className={styles.charts}>
                  <DashboardCharts entities={entities} />
                </article>
                <article className={styles.insights}>
                  <h4 className={styles.secondaryTitle}>
                    <FormattedMessage {...messages.titles.insights} />
                  </h4>
                  <DashboardInsights counts={entities} />
                </article>
              </div>
            </section>
            <section className={styles.lower}>
              <h3 className={styles.primaryTitle}>
                <FormattedMessage {...messages.titles.resolvers} />
              </h3>
              <DashboardResolvers resolvers={resolvers} />
            </section>
          </main>
        </DashboardBackdrop>
      </section>
    </div>
  )
}

export default injectIntl(Dashboard)
